// src/components/admin/Sidebar.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { auth } from '../../config/firebaseConfig';
import { signOut } from 'firebase/auth';
import Swal from 'sweetalert2';
import {
  faHouse,
  faInfoCircle,
  faUtensils,
  faUsers,
  faImage,
  faNewspaper,
  faQuoteRight,
  faQuestionCircle,
  faEnvelope,
  faEnvelopeOpenText,
  faLeaf,
  faBars,
  faSection,
  faUser,
  faSearch,
  faRightFromBracket,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import logo from './logo.svg';

const Sidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    { path: '/home', label: 'Home', icon: faHouse },
    { path: '/about', label: 'About Us', icon: faInfoCircle },
    { path: '/flavours-of-vivaak', label: 'Flavours of Vivaak', icon: faUtensils },
    { path: '/hospitality', label: 'Hospitality Team', icon: faUsers },
    { path: '/gallery', label: 'Gallery', icon: faImage },
    { path: '/blogs', label: 'Blogs', icon: faNewspaper },
    { path: '/testimonials', label: 'Testimonials', icon: faQuoteRight },
    { path: '/faqs', label: 'Faqs', icon: faQuestionCircle },
    { path: '/contact', label: 'Contact Us', icon: faEnvelope },
    { path: '/enquiries', label: 'Enquiries', icon: faEnvelopeOpenText },
    { path: '/pages', label: 'Page Manager', icon: faSection },
    { path: '/navbar', label: 'Navbar', icon: faBars },
    { path: '/seo', label: 'SEO Management', icon: faSearch },
    { path: '/settings', label: 'Admin Profile', icon: faUser }
  ];

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to log out of the admin portal?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout"
    });

    if (result.isConfirmed) {
      try {
        await signOut(auth);
        navigate('/login');
      } catch (err) {
        console.error("Logout error:", err);
      }
    }
  };

  return (
    <aside className={`fixed top-0 left-0 h-full ${collapsed ? 'w-16' : 'w-64'} bg-gray-800 text-white flex flex-col justify-between overflow-y-auto scrollbar-hide transition-all duration-300`}>
      {/* Toggle button */}
      <button
        onClick={onToggle}
        className="absolute -right-3 top-6 z-50 bg-white text-gray-800 rounded-full w-7 h-7 flex items-center justify-center shadow-lg border-2 border-gray-300 hover:bg-gray-100"
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <FontAwesomeIcon icon={collapsed ? faChevronRight : faChevronLeft} className="text-xs" />
      </button>

      <div className={`${collapsed ? 'px-2 pt-6' : 'p-6'}`}>
        {!collapsed && <img src={logo} alt='logo' className='w-full max-w-[180px] h-auto object-contain' style={{ maxWidth: '180px', height: 'auto' }} />}
        {collapsed && <div className="h-12" />}
        <nav className="flex flex-col space-y-4 my-8">
          {items.map(item => {
            const active = pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                title={collapsed ? item.label : ''}
                className={`flex items-center ${collapsed ? 'justify-center' : 'space-x-3'} text-left p-2 rounded ${active ? 'bg-gray-600 text-[#FFD1A0]' : 'hover:bg-gray-600'}`}
              >
                <FontAwesomeIcon icon={item.icon} />
                {!collapsed && <span>{item.label}</span>}
              </button>
            );
          })}
        </nav>
      </div>

      <button
        onClick={handleLogout}
        title={collapsed ? 'Logout' : ''}
        className={`flex items-center ${collapsed ? 'justify-center px-2' : 'space-x-3 px-6'} text-left p-2 rounded hover:bg-red-600 transition-colors mt-auto border-t border-gray-700 py-4`}
      >
        <FontAwesomeIcon icon={faRightFromBracket} />
        {!collapsed && <span>Logout</span>}
      </button>
    </aside>
  );
};

export default Sidebar;
